import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CabinetLayout from "../layouts/CabinetLayout";
import {
  Home as HomePage,
  Export as ExportPage,
  Profile as ProfilePage,
  Complex as ComplexPage,
  Materials as MaterialsPage,
  HiddenGrz as HiddenGrzPage,
  Reports as ReportsPage,
  Documents as DocumentsPage,
  HtmlDocumentViewer as HtmlDocumentViewerPage,
  Addresses as AddressesPage,
  Tasks as TasksPage,
} from "../pages";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<CabinetLayout title="Главная"><HomePage/></CabinetLayout>}/>
      <Route path="/materials" element={<CabinetLayout title="Материалы"><MaterialsPage/></CabinetLayout>}/>
      <Route path="/complex" element={<CabinetLayout title="Комплексы"><ComplexPage/></CabinetLayout>}/>
      <Route path="/export" element={<CabinetLayout title="Результаты экспорта"><ExportPage/></CabinetLayout>}/>
      <Route path="/profile" element={<CabinetLayout title="Профиль"><ProfilePage/></CabinetLayout>}/>
      <Route path="/hidden-grz" element={<CabinetLayout title="Скрытые государственные регистрационные знаки"><HiddenGrzPage/></CabinetLayout>}/>
      <Route path="/reports" element={<CabinetLayout title="Отчеты"><ReportsPage/></CabinetLayout>}/>
      <Route path="/addresses" element={<CabinetLayout title="Адреса"><AddressesPage/></CabinetLayout>}/>
      <Route path="/tasks" element={<CabinetLayout title="Задания"><TasksPage/></CabinetLayout>}/>
      <Route path="/documents/view" element={<HtmlDocumentViewerPage />} />
      <Route path="/documents" element={<CabinetLayout title="Документы"><DocumentsPage/></CabinetLayout>}/>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
